const svgConfig = require('../../json/svg.json');
import { loadDoorSettingsState } from '../../assets/scripts/service/localStorage-service';

export const sidebarMenu = (() => {

	const $sideLink = $('.js-link', '.sidebar__menu');
	const $sideLinkToPopup = $('.js-link-popup', '.sidebar__menu');
	const $closeCustomizePanelButton = $( '.js-close-customize-panel' );

	//function looks for the data attribute "data-panel" and opens the panel with the same id
    $sideLink.on( 'click', function( e ) {
        e.preventDefault;
        const $this = $( this );
		const dataPanelAttr = $this.attr( 'data-panel' );
		const $startPage = $( '.start-page' );
		const $presetPage = $( '.preset-page' );
		const $useLastCalculationButton = $( '.js-use-last-calculation-btn', '.start-page' );
		$('.hamburger__inner, .sidebar').removeClass('open').removeClass('sidebar__visible-mobile');

		//Updates the sliders outside subscribe function to prevent stack overflow
		$('.range-slider input[type=range]').trigger('change');


		// HOME LINK CLICKED
		if ( $this.hasClass( 'home-link' ) ) {
			// make this home-link side-menu link open the first page
			//$('.assa-abloy-logo').removeClass('show');
			if ( loadDoorSettingsState() !== undefined ) {
				$useLastCalculationButton.show();
			}
			$presetPage.removeClass('is--visible');
			$startPage.show();
			closeCustomizePanel();
			$('.hamburger').hide();
			return;
		}

		// MIDDLE MENU LINKS
		if ( $this.hasClass( 'sidebar__link--active' ) ) {
			if ( $( '#' + dataPanelAttr ).hasClass( 'is--visible' ) ) {
				return;
			}
			// $( '.sidebar__link' ).removeClass( 'sidebar__link--active' );
			$( '.sidepanel, .modal, .preset-page, .overlay').removeClass( 'is--visible' );
		} else {
			$( '.sidebar__link' ).removeClass( 'sidebar__link--active' );
			$( '.sidepanel, .modal, .preset-page, .overlay' ).removeClass( 'is--visible' );
			$this.addClass( 'sidebar__link--active' );
			$( '#' + dataPanelAttr ).addClass( 'is--visible' );
		}

		// Add and remove overlay if sidepanel customize is open
		if( $( '.sidepanel--customize' ).hasClass( 'is--visible' ) ) {
			$( '.overlay' ).addClass( 'is--visible' );
			if ( $( window ).width() <= 668 ) {
				$( '.mobile-close-customize-wrapper' ).addClass( 'is--visible' );
			}
		} else {
			$( '.overlay' ).removeClass( 'is--visible' );
			if ( $( window ).width() <= 668 ) {
				$( '.mobile-close-customize-wrapper' ).removeClass( 'is--visible' );
			}
		}

		// If sidepanel-customize is open add class that compresses the resultpage
		if ( $( '.sidepanel--customize' ).hasClass( 'is--visible' ) ) {
			$( '.result-page' ).addClass( 'result-page--is-compressed' );
			$( '.fake-load' ).fadeIn('slow');
			if ( $( window ).width() <= 668 ) {
				$('.mobile-close-customize-wrapper').fadeIn('slow');
			}
		} else {
			$( '.result-page' ).removeClass( 'result-page--is-compressed' );
			$( '.fake-load' ).hide();
		}
		
	});

	// BOTTOM MENU LINKS
	$sideLinkToPopup.on( 'click', function( e ) {
		e.preventDefault;
		const $this = $( this );
		const dataPanelAttr = $this.attr( 'data-panel' );

		if ( $this.hasClass( 'sidebar__link--active' ) && $( '#' + dataPanelAttr ).hasClass( 'is--visible' ) ) {
			$( '.modal').removeClass( 'is--visible' );
			$( '.overlay-popup').removeClass( 'is--visible' );
		} else {
			$( '.modal' ).removeClass( 'is--visible' );
			$( '#' + dataPanelAttr ).addClass( 'is--visible' );
			$( '.overlay-popup' ).removeClass( 'is--visible' );
			$( '.overlay-popup' ).addClass( 'is--visible' );
		}

		// Add and remove overlay-popup if sidepanel customize or modal is open
		if( $( '.modal' ).hasClass( 'is--visible' ) ) {
			$( '.overlay-popup' ).removeClass('overlay--visible');
			$( '.overlay-popup' ).addClass( 'is--visible' );
		} else {
			$( '.overlay-popup' ).removeClass( 'is--visible' );
		}

	});

	// CLOSE CUSTOMIZE PANEL
	$closeCustomizePanelButton.on( 'click', function( e ) {
		if($('.fake-load').hasClass('error-state')){
			return false;
		}
		closeCustomizePanel();
	});

	function closeCustomizePanel() {
		$( '.overlay' ).removeClass( 'is--visible' );
		$( '.result-page' ).removeClass( 'result-page--is-compressed' );
		$( '.sidepanel, .modal, .preset-page, .overlay').removeClass( 'is--visible' ); // All Side Panels
		$( '.fake-load' ).hide();
		$( '.sidebar__link' ).removeClass( 'sidebar__link--active' );
		$('.sidebar__link.result-page-link').addClass( 'sidebar__link--active' );
	}

})();



// WEBPACK FOOTER //
// ./src/components/sidebar-menu/sidebar-menu.js